import React, { useState } from "react";
import {
	AppBar,
	Button,
	CssBaseline,
	IconButton,
	makeStyles,
	MenuItem,
	Toolbar,
	Typography,
} from "@material-ui/core";
import NavDrawer from "../NavDrawer";
import clsx from "clsx";
import { FaBars, FaSearch, FaUserCircle } from "react-icons/fa";
import NavbarLinkList from "./NavbarLinkList";
import { navDataHelp, navDataPrimary } from "../NavDrawer/data";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import { Link } from "gatsby";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	title: {},
	menuButton: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up("md")]: {
			display: "none",
		},
	},
	appBar: {
		backgroundColor: theme.palette.common.white,
		color: theme.palette.common.black,
		maxWidth: "1200px",
		margin: "auto",
	},
	sectionDesktop: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	sectionMobile: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "flex-end",
		flexGrow: 1,
	},
	hideButton: {
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
}));

const NavBar = () => {
	const siteTitle = "Unity";

	const classes = useStyles();

	const [open, setOpen] = useState(false);

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar
				position="static"
				variant="elevation"
				elevation={0}
				className={classes.appBar}
			>
				<Toolbar>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						onClick={handleDrawerOpen}
						edge="start"
						className={clsx(classes.menuButton)}
					>
						<FaBars />
					</IconButton>

					<MenuItem to="/" component={Link} className={classes.title}>
						<Typography variant="h6">{siteTitle}</Typography>
					</MenuItem>

					<div className={classes.sectionDesktop}>
						<NavbarLinkList data={navbarLinkListData} />
					</div>
					<div className={classes.sectionMobile}>
						<Button
							variant="contained"
							className={classes.hideButton}
							style={{
								backgroundColor: "#2196f3",
								color: "white",
								textTransform: "initial",
							}}
						>
							Get Started
						</Button>

						<IconButton>
							<FaSearch />
						</IconButton>
						<IconButton>
							<BsFillGrid3X3GapFill />
						</IconButton>
						<IconButton>
							<FaUserCircle />
						</IconButton>
					</div>
				</Toolbar>
			</AppBar>
			<NavDrawer
				open={open}
				siteTitle={siteTitle}
				handleClick={handleDrawerClose}
			/>
		</div>
	);
};

export default NavBar;

const navbarLinkListData = navDataPrimary.concat(navDataHelp);
